import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { Grid, Popup } from "semantic-ui-react";
import MyTextInput from "../form/MyTextInput";
import MyEmailInput from "./MyEmailInput";
import MyCheckbox from "./MyCheckbox";

function isSecondaryOrTertiaryClient(role) {
  return (  // code doesnt work well so only allow secondary client to share email
    role === "Buyer 2" ||
    // role === "Buyer 3" ||
    role === "Seller 2" 
    // role === "Seller 3"
  );
}

function getPrimaryClientFieldKey(role) {
  if (role?.startsWith("Buyer")) {
    return "client.";
  } else if (role?.startsWith("Seller")) {
    return "client.";
  }
  return null;
}

export default function FormParty({ fieldKey = "", edit, role, newPerson }) {
  const { values, setFieldValue } = useFormikContext();
  // Use the current form role value if available, otherwise fall back to prop
  const currentRole = values?.role || role;

  // Auto-check the "shares email" checkbox when email matches primary client
  useEffect(() => {
    if (isSecondaryOrTertiaryClient(currentRole)) {
      const primaryFieldKey = getPrimaryClientFieldKey(currentRole);
      if (primaryFieldKey) {
        // Get current email based on fieldKey
        let currentEmail;
        if (fieldKey === "clientSecondary.") {
          currentEmail = values?.clientSecondary?.email;
        } else if (fieldKey === "clientThird.") {
          currentEmail = values?.clientThird?.email;
        } else if (fieldKey) {
          // For other field keys, try to extract the object name
          const objectName = fieldKey.replace(".", "");
          currentEmail = values?.[objectName]?.email;
        } else {
          currentEmail = values?.email;
        }

        const primaryEmail = values?.client?.email;

        // If both emails exist and match, auto-check the checkbox
        if (currentEmail && primaryEmail && currentEmail === primaryEmail) {
          const sharesEmailFieldName = fieldKey + "sharesEmailWithPrimary";

          // Check current checkbox value
          let currentCheckboxValue;
          if (fieldKey === "clientSecondary.") {
            currentCheckboxValue =
              values?.clientSecondary?.sharesEmailWithPrimary;
          } else if (fieldKey === "clientThird.") {
            currentCheckboxValue = values?.clientThird?.sharesEmailWithPrimary;
          } else if (fieldKey) {
            const objectName = fieldKey.replace(".", "");
            currentCheckboxValue = values?.[objectName]?.sharesEmailWithPrimary;
          } else {
            currentCheckboxValue = values?.sharesEmailWithPrimary;
          }

          if (!currentCheckboxValue) {
            setFieldValue(sharesEmailFieldName, true);
          }
        }
      }
    }
  }, [values, currentRole, fieldKey, setFieldValue]);

  // Clear email when "shares email" checkbox is checked
  useEffect(() => {
    if (isSecondaryOrTertiaryClient(currentRole)) {
      // Get checkbox value
      let sharesEmailChecked;
      if (fieldKey === "clientSecondary.") {
        sharesEmailChecked = values?.clientSecondary?.sharesEmailWithPrimary;
      } else if (fieldKey === "clientThird.") {
        sharesEmailChecked = values?.clientThird?.sharesEmailWithPrimary;
      } else if (fieldKey) {
        const objectName = fieldKey.replace(".", "");
        sharesEmailChecked = values?.[objectName]?.sharesEmailWithPrimary;
      } else {
        sharesEmailChecked = values?.sharesEmailWithPrimary;
      }

      // If checkbox is checked, clear the email field
      if (sharesEmailChecked) {
        // Get current email
        let currentEmail;
        if (fieldKey === "clientSecondary.") {
          currentEmail = values?.clientSecondary?.email;
        } else if (fieldKey === "clientThird.") {
          currentEmail = values?.clientThird?.email;
        } else if (fieldKey) {
          const objectName = fieldKey.replace(".", "");
          currentEmail = values?.[objectName]?.email;
        } else {
          currentEmail = values?.email;
        }

        // Clear email if it has a value
        if (currentEmail) {
          const emailFieldName = fieldKey + "email";
          setFieldValue(emailFieldName, "");
        }
      }
    }
  }, [values, currentRole, fieldKey, setFieldValue]);

  // Determine if email field should be disabled (when shares email checkbox is checked)
  const getSharesEmailChecked = () => {
    if (!isSecondaryOrTertiaryClient(currentRole)) return false;

    if (fieldKey === "clientSecondary.") {
      return values?.clientSecondary?.sharesEmailWithPrimary;
    } else if (fieldKey === "clientThird.") {
      return values?.clientThird?.sharesEmailWithPrimary;
    } else if (fieldKey) {
      const objectName = fieldKey.replace(".", "");
      return values?.[objectName]?.sharesEmailWithPrimary;
    } else {
      return values?.sharesEmailWithPrimary;
    }
  };

  const emailDisabled = getSharesEmailChecked();

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column mobile={16} computer={5}>
          <MyTextInput
            name={fieldKey + "firstName"}
            label={"First name"}
            data-test="firstName"
          />
        </Grid.Column>
        <Grid.Column mobile={16} computer={5}>
          <MyTextInput
            name={fieldKey + "middleName"}
            label={"Middle name"}
            data-test="middleName"
          />
        </Grid.Column>
        <Grid.Column mobile={16} computer={5}>
          <MyTextInput
            name={fieldKey + "lastName"}
            label={"Last name"}
            data-test="lastName"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="zero top padding">
        <Grid.Column mobile={16} computer={8}>
          {!newPerson && (role === "TC (Mine)" || role === "TC") ? (
            <Popup
              content="Email for this role cannot be changed. You can delete this party and create a new party for this role with the correct email."
              className="background-orange"
              trigger={
                <MyEmailInput
                  name={fieldKey + "email"}
                  label="Email"
                  readOnly={true}
                  data-test="email"
                />
              }
            />
          ) : emailDisabled ? (
            <Popup
              content="Email is shared with primary client. Uncheck the checkbox to enter a different email."
              className="background-orange"
              trigger={
                <MyEmailInput
                  name={fieldKey + "email"}
                  label="Email"
                  disabled={true}
                  data-test="email"
                />
              }
            />
          ) : (
            <MyEmailInput
              name={fieldKey + "email"}
              label="Email"
              data-test="email"
            />
          )}
      </Grid.Column>
          {isSecondaryOrTertiaryClient(currentRole) && (
            <Grid.Column mobile={16} computer={8} style={{ paddingTop: "20px" }}>
              <MyCheckbox
                name={fieldKey + "sharesEmailWithPrimary"}
                label={`Client shares email with primary ${
                  currentRole?.startsWith("Buyer") ? "buyer" : "seller"
                }`}
              />
            </Grid.Column>
          )}
          </Grid.Row>
          <Grid.Row className="zero top padding">
        <Grid.Column mobile={16} computer={5}>
          <MyTextInput
            name={fieldKey + "phone"}
            label="Phone"
            data-test="phone"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
